import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { LargeCard } from "components/home/Home";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useParams } from "react-router-dom";
import ECLCardIcon from "static/images/ECLCardIcon.svg";
import { useGetAllDealsQuery } from "store/apis/rewards";

const eclPerkId = process.env.PUBLIC_ECL_PERK_ID;

export const ECLHomeCard = () => {
  const { uuid: groupUuid } = useCurrentGroupContext();
  const { groupId } = useParams<{ groupId: string }>();
  const { data } = useGetAllDealsQuery({ groupId: groupUuid || groupId });
  const { isCustomer } = useRoleBasedView();

  const eclPerkSlug = data?.perks.find(
    (perk) => perk?.perk_id === eclPerkId
  )?.slug;

  const perkLink = isCustomer
    ? `/community/perks/${eclPerkSlug}`
    : `perks/${eclPerkSlug}`;

  return (
    <LargeCard block>
      <div className="t-h-full t-min-h-[132px] t-w-full t-bg-surface-lighter-grey t-rounded-lg t-border t-border-solid t-border-neutral-10 t-flex t-flex-col t-gap-3 t-p-5 md:t-flex-row md:t-items-start md:t-justify-between sm:t-justify-center">
        <div className="t-flex t-gap-3 t-items-start">
          <img className="t-h-8 t-w-8 sm:t-shrink-0" src={ECLCardIcon} alt="" />
          <div className="t-flex t-flex-col t-gap-1">
            <div className="t-text-subtext t-text-text-100">
              Unlock up to 65% of Your Revenue in Non-Dilutive Financing!
            </div>
            <div className="t-text-body-sm t-text-text-30">
              <div>✅ Get up to $2M with Efficient Capital Labs</div>
              <div>✅ Exclusive Offer: 25 bps fee discount through Inkle</div>
            </div>
          </div>
        </div>
        <ConditionalLink to={perkLink} className="t-block t-w-fit sm:t-ml-11">
          <Button customType="secondary" size="small">
            View
          </Button>
        </ConditionalLink>
      </div>
    </LargeCard>
  );
};
